import { DepartureReportRequestModel } from '../api/models/DepartureReportRequestModel';
import { DepartureReportFormModel } from '../models';

export const dataFormToRequest = (data: DepartureReportFormModel): DepartureReportRequestModel => ({
  from: data.from,
  to: data.to,
  card_ids: data.card_ids.map(card => card.id),
  rate_ids: data.rate_ids,
  room_type_ids: data.room_type_ids,
  ...(String(data.state) !== 'all' ? { state: data.state } : {}),
  balance: data.balance,
  nationality_ids: (data.nationality_ids ?? []).map(item => Number(item.id)),
  sort_by: data.sortBy,
  direction: data.sortDirection,
  ...(data.grouped ? { group_by: 'market_agency' } : {}),
  exclude_partial: data.exclude_partial,
  file_type: data.file_type,
});
